import { PrinterFilled, HomeOutlined } from "@ant-design/icons";
import { Button, Card, Checkbox, Flex, Pagination, Row, Col, Breadcrumb } from "antd";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation, useParams } from "react-router-dom";
import Loader from "../../fields/loader/Loader";
import { getRoomData, resetItemDatas } from "../../store/reducer/roomSlice";
import PageHeader from "../../view/pageheader";
import { assestURL } from "../../services/config";
import ValuationItemCard from "./ValuationItemCard";
import NoResultsModal from "./NoResultsModal";
import { searchProduct, searchGPTName, resetUpdateStatus } from "../../store/reducer/googleSearch";
import { toast } from "react-toastify";

const ValuationView = () => {
   const { roomid } = useParams();
   const location = useLocation();
   const { returnUrl, breadCrumb } = location.state;
   const [pageSize, setPageSize] = useState(50);
   const dispatch = useDispatch();
   const [selectAll, setSelectAll] = useState([]);
   const [selectedItems, setSelectedItems] = useState([]);
   const [nameSearch, setNameSearch] = useState(false);
   const [estimateSearch, setEstimateSearch] = useState(false);
   const [dataIds, setDataIds] = useState([]);
   const { getItemDatas, getRoomLoading } = useSelector(state => state.rooms);
   const {
      googleSearchLoading,
      googleSearchSuccess,
      googleSearchError,
      googleSearchErrorMessage,
      googleUpdateValueSuccess,
      googleUpdateValueError,
      googleUpdateValueErrorMessage,
      NameSearchLoading,
      NameSearchSuccess
   } = useSelector(state => state.googleSearch);

   useEffect(() => {
      dispatch(getRoomData({ room_id: atob(roomid), limit: pageSize }));
   }, []);
   console.log(getItemDatas, "getItemDatas==");

   useEffect(() => {
      console.log("getItemDatas changed:", getItemDatas);
      if (getItemDatas?.data?.length) {
         const { data, googleItemIds } = getItemDatas;
         let ids = data.map(item => item.id);
         setDataIds(ids);
         setSelectAll([...googleItemIds]);
      }
   }, [getItemDatas]);

   useEffect(() => {
      if ((googleSearchSuccess && NameSearchSuccess) && (nameSearch && estimateSearch)) {
         toast.dismiss();
         dispatch(resetItemDatas({}));
         dispatch(resetUpdateStatus({}));
         setSelectedItems([]);
         setEstimateSearch(false);
         setNameSearch(false);
         dispatch(getRoomData({ room_id: atob(roomid), limit: pageSize }));
         toast.success("Name search & AI Estimation Completed!.");
      }
      else if (googleSearchSuccess && estimateSearch && !nameSearch) {
         toast.dismiss();
         dispatch(resetItemDatas({}));
         dispatch(resetUpdateStatus({}));
         setSelectedItems([]);
         setEstimateSearch(false);
         dispatch(getRoomData({ room_id: atob(roomid), limit: pageSize }));
         toast.success("AI Estimation Completed!.");
      }
      else if (NameSearchSuccess && nameSearch && !estimateSearch) {
         toast.dismiss();
         dispatch(resetItemDatas({}));
         dispatch(resetUpdateStatus({}));
         setNameSearch(false);
         setSelectedItems([]);
         dispatch(getRoomData({ room_id: atob(roomid), limit: pageSize }));
         toast.success("Name search Completed!.");
      }
      if (googleSearchError) {
         toast.error(googleSearchErrorMessage);
      }
      if (googleUpdateValueSuccess) {
         toast.dismiss();
         toast.success("Value updated.");
         dispatch(getRoomData({ room_id: atob(roomid), limit: pageSize }));
      }
      if (googleUpdateValueError) {
         toast.error(googleUpdateValueErrorMessage);
      }
      // if (
      //    googleSearchSuccess ||
      //    googleUpdateValueError ||
      //    googleUpdateValueSuccess ||
      //    googleSearchError ||
      //    NameSearchLoading ||
      //    NameSearchSuccess
      // ) {
      //    dispatch(resetUpdateStatus({}));
      // }
   }, [
      googleSearchError,
      googleSearchLoading,
      googleSearchSuccess,
      googleUpdateValueSuccess,
      googleUpdateValueError,
      googleUpdateValueErrorMessage,
      NameSearchLoading,
      NameSearchSuccess
   ]);

   useEffect(() => {
      if (!selectedItems.length) {
         setEstimateSearch(false);
         setNameSearch(false);
      }
   }, [selectedItems]);

   const handleGenerate = e => {
      if (selectedItems?.length) {
         if (estimateSearch) {
            const postData = {
               filteredgoogleSearchItem: selectedItems,
            };
            dispatch(searchProduct({ postData }));
         }
         if (nameSearch) {
            const searchData = {
               filteredgoogleSearchItem: selectedItems,
            }
            dispatch(searchGPTName({ searchData }));
         };
         toast.info("Estimating...");
      } else {
         toast.error("Please select Items to estimate!");
      }
   };

   return (
      <div>
         <Loader loading={getRoomLoading} />
         <NoResultsModal />
         <div className="container-fluid">
            <PageHeader
               HeaderText="Valuation View"
               //    Breadcrumb={[{ name: "TakeStock Portal Users" }]}
               backButtonUrl={returnUrl}
               buttonName="Return to Room"
            />
            <Breadcrumb
               className="mb-3"
               style={{ marginTop: -15 }}
               items={breadCrumb
                  ?.map(item =>
                     item.title === "Home"
                        ? {
                           title: (
                              <Link to={item.href}>
                                 <HomeOutlined />
                              </Link>
                           ),
                           //   href: item.href,
                        }
                        : item.room
                           ? { title: <Link to={returnUrl}>{item.title}</Link> }
                           : { title: <Link to={item.href}>{item.title}</Link> }
                  )
                  .concat([{ title: "Valuation View" }])}
            />
            <Card
               title="Valuation View"
               extra={
                  <Button
                     icon={<PrinterFilled />}
                     type="primary"
                     shape="round"
                     className="text-white"
                     style={{ backgroundColor: "#F7931E" }}
                     onClick={handleGenerate}
                  >
                     Generate Estimate
                  </Button>
               }
            >
               <Flex justify="space-between" className="mb-3">
                  <Button
                     shape="round"
                     className="border-0"
                     style={{
                        backgroundColor:
                           selectedItems?.length === getItemDatas?.googleItemIds?.length
                              ? "#F7931E"
                              : "lightgrey",
                     }}
                  >
                     <Checkbox
                        className="text-left"
                        // checked={selectedItems?.length >= dataIds?.length}
                        checked={selectedItems?.length === getItemDatas?.googleItemIds?.length}
                        onChange={e => {
                           if (e.target.checked) {
                              setSelectedItems([...selectAll]);
                           } else {
                              setSelectedItems([]);
                              setEstimateSearch(false);
                              setNameSearch(false);
                           }
                        }}
                     >
                        Select All
                     </Checkbox>
                  </Button>
                  <Button
                     shape="round"
                     className="border-0"
                     style={{
                        backgroundColor:
                           nameSearch
                              ? "#F7931E"
                              : "lightgrey",
                     }}
                  >
                     <Checkbox
                        className="text-left"
                        checked={nameSearch}
                        onChange={e => {
                           if (e.target.checked) {
                              if (selectedItems?.length) {
                                 setNameSearch(true)
                              } else {
                                 toast.error("Please select Items to search!")
                              }
                           } else {
                              setNameSearch(false)
                           }
                        }}
                     >
                        Include ChatGPT Name Search
                     </Checkbox>
                  </Button>
                  <Button
                     shape="round"
                     className="border-0"
                     style={{
                        backgroundColor:
                           estimateSearch
                              ? "#F7931E"
                              : "lightgrey",
                     }}
                  >
                     <Checkbox
                        className="text-left"
                        checked={estimateSearch}
                        onChange={e => {
                           if (e.target.checked) {
                              if (selectedItems?.length) {
                                 setEstimateSearch(true)
                              } else {
                                 toast.error("Please select Items to search!")
                              }
                           } else {
                              setEstimateSearch(false)
                           }
                        }}
                     >
                        Include AI Estimate in Search
                     </Checkbox>
                  </Button>
                  <Pagination
                     total={getItemDatas?.counts}
                     showTotal={(total, range) => `${range[0]} - ${range[1]} of ${total} items`}
                     showSizeChanger={true}
                     size="small"
                     pageSize={pageSize}
                     pageSizeOptions={
                        getItemDatas?.counts > 100 ? [50, 100, getItemDatas?.counts] : [50, 100]
                     }
                     onChange={(page, pageSize) => {
                        setPageSize(pageSize);
                        setSelectedItems([]);

                        dispatch(
                           getRoomData({
                              room_id: atob(roomid),
                              page: page,
                              limit: pageSize,
                           })
                        );
                     }}
                  />
               </Flex>
               <Row
                  gutter={[12, 12]}
                  className="overflow-y-auto"
                  style={{ height: 500, scrollbarWidth: "thin" }}
               >
                  {getItemDatas?.data?.map(item => (
                     <Col span={6} key={item.id}>
                        <ValuationItemCard
                           imageUrl={assestURL + item.item_image}
                           id={item.id}
                           title={item?.name}
                           aiValue={item.google_value_range}
                           selectedItems={selectedItems}
                           setSelectedItems={setSelectedItems}
                           allItems={selectAll}
                           dataIds={dataIds}
                        />
                     </Col>
                  ))}
               </Row>
            </Card>
         </div>
      </div>
   );
};

export default ValuationView;
